var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 28,
    viewBox: "0 0 104 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5768 12.6839H41.8937V16.0582L43.0329 16.8958H46.1594V19.0377H45.1536H41.4817L39.3368 16.9198V12.7437L42.3421 9.77617H45.8807H46.2927H49.8555V6.41378L48.7164 5.57617H39.5064L34.5137 10.5061V17.4822L39.5064 22.4121L40.6455 23.2497H47.2985H49.2859H50.7038V13.5334L49.5768 12.6839Z",
    fill: "url(#paint0_linear_89_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3111 8.93856L65.7542 6.41378L64.615 5.57617H53.248V8.53173V12.3129V12.7198V15.6753V22.4121L54.3872 23.2497H57.7924V16.5129H61.2461L63.4759 22.4121L64.615 23.2497H68.3111L65.7542 16.5129L68.3111 13.9881V8.93856ZM57.7924 12.3129V12.1693V10.7693V9.78814H63.4759V11.4753L62.6276 12.3129H59.6465H57.7924V12.3129Z",
    fill: "url(#paint1_linear_89_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6836 9.77617V6.41378L83.5444 5.57617H73.874H70.4688V8.93856V12.3129V15.6753V19.0377V21.5625V22.4121L71.6079 23.2497H84.6836V19.8873L83.5444 19.0377H75.0131V16.5129H83.2536V13.1505L82.1145 12.3129H75.0131V9.77617H84.6836Z",
    fill: "url(#paint2_linear_89_2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.873 5.57617H98.3166L95.0447 10.3027L92.3544 6.41378L91.2153 5.57617H86.6709L92.4998 13.9881L86.6709 22.4121L87.81 23.2497H92.3544L95.6263 18.5232L98.3166 22.4121L99.4557 23.2497H104L98.1833 14.8377L104 6.41378L102.873 5.57617Z",
    fill: "url(#paint3_linear_89_2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8382 21.5026L17.6443 21.5983V21.335L17.4504 21.4308V21.1675L17.2565 21.2513V20.988L17.0626 21.0838V20.8205L16.8687 20.9043V20.641L16.6748 20.7368V20.4735L16.4809 20.5692V20.294L16.287 20.3897V20.1265L16.0931 20.2222V19.947L15.8993 20.0427V19.7795L14.9904 20.2103L14.8692 20.2462L14.7965 20.0427L14.6753 20.0667L14.6026 19.8632L14.4814 19.8991L14.4087 19.6957L14.2875 19.7316L14.2148 19.5162L14.0936 19.5521L14.0209 19.3487L13.8997 19.3846L13.827 19.1692L13.7058 19.2051L13.6331 19.0017L13.5119 19.0376L13.4392 18.8342L12.3607 19.1214L12.3001 18.9299L12.1789 18.9538L12.1062 18.7504L11.985 18.7863L11.9123 18.5829L11.7911 18.6068L11.7184 18.4034L11.5972 18.4393L11.5245 18.2359L11.4033 18.2718L11.3306 18.0564L11.2095 18.0923L11.1367 17.8889L11.0156 17.9248L10.9429 17.7094L10.8217 17.7453L10.749 17.5419L8.70096 18.0923L8.25258 17.8769V11.1402L10.8338 9.90769L12.8939 10.4581L13.5119 8.62735L13.5241 8.61538L15.5842 9.16581L16.2022 7.33504L18.0321 8.22051V2.75214L17.8382 2.65641V2.57265L17.6443 2.48889V2.40513L17.4504 2.32137V2.23761L17.2565 2.14188V2.05812L17.0626 1.97436V1.8906L16.8687 1.79487V1.71111L16.6748 1.62735V1.54359L16.4809 1.44786V1.3641L16.287 1.28034V1.19658L16.0931 1.10085V1.02906L15.8993 0.933333V0.849573L14.0573 0L0 6.52137V19.5761L0.193893 19.6598V19.7436L0.387787 19.8393V19.9111L0.58168 20.0068V20.0906L0.775573 20.1744V20.2581L0.969467 20.3538V20.4376L1.16336 20.5214V20.6051L1.35725 20.7009V20.7846L1.55115 20.8684V20.9521L1.74504 21.0479V21.1197L1.93893 21.2154V21.2991L2.13283 21.3829V21.4667L16.2022 28L18.0321 27.1385V21.6821L17.8382 21.7778V21.5026Z",
    fill: "url(#paint4_linear_89_2)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6177 12.9592V12.7797H27.4238V12.6122H27.2299V12.4327H27.036V12.2652H26.8421V12.0857H26.6482V11.9182H26.4543V11.7507H26.2604V11.5712H26.0666V11.4036H25.8727V11.2242H25.6788V11.0566H15.7175L10.8096 13.6054H11.3307L11.0035 13.7729L11.5246 13.7848L11.1974 13.9524H11.7184L11.3913 14.1199L11.9123 14.1319L11.5851 14.2994H12.1062L11.779 14.4669H12.3001L11.9729 14.6464H12.494L12.1668 14.8139H12.6879L12.3607 14.9934H12.8818L12.5546 15.1609H13.0757L12.7485 15.3284L13.2817 15.3404L12.9424 15.5079L20.783 15.5319V20.8447L20.9769 20.7489V21.0242L21.1707 20.9284V21.1917L21.3646 21.096V21.3712L21.5585 21.2635V21.5387L21.7524 21.443V21.7182L21.9463 21.6105V21.8857L22.1402 21.79V22.0532L22.3462 21.9575V22.2327L22.5401 22.137V22.4002L22.734 22.3045V22.5797L22.9279 22.472V22.7472L27.8116 20.2344V12.9592H27.6177Z",
    fill: "url(#paint5_linear_89_2)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7175 11.0566L10.8096 13.6054L20.783 13.6413V20.8447L25.6788 18.3438V11.0566H15.7175Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0573 20.653L13.4392 18.8342L11.3912 19.3726H11.367L10.749 17.5419L8.70096 18.0923L6.10764 16.8479V9.23761L8.70096 8.00513L10.7611 8.55556L11.367 6.72479L11.3791 6.71282L13.4513 7.26325L14.0694 5.43248L15.8993 6.31795V0.849573L14.0573 0L0 6.52137V19.5761L14.0573 26.0974L15.8993 25.2479V19.7795L14.0573 20.653Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0509 8.10096L64.494 5.57617H53.127V8.53173V12.3129V12.7198V15.6753V22.4121H56.5322V15.6753H60.7979L63.3548 22.4121H67.0509L64.5061 15.6753L67.063 13.1505V8.10096H67.0509ZM56.5443 12.3129V11.3317V9.91976V8.93856H62.5187L63.3669 9.77617V11.4634L62.5187 12.301H59.5376H56.5443V12.3129Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.873 5.57617H98.3166L94.7659 10.7095L91.2153 5.57617H86.6709L92.4998 13.9881L86.6709 22.4121H91.2153L94.7659 17.2787L98.3166 22.4121H102.873L97.0442 13.9881L102.873 5.57617Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5444 8.93856V5.57617H73.874H70.4688V8.93856V12.3129V15.6753V19.0377V21.5625V22.4121H83.5444V19.0377H73.874V15.6753H82.1145V12.3129H73.874V8.93856H83.5444Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5768 12.6839H41.8937V16.0582H46.1594V19.0377H45.1536H41.203L38.2098 16.0822V11.8941L41.203 8.93856H44.7415H45.1536H48.7164V5.57617H39.5064L34.5137 10.5061V17.4822L39.5064 22.4121H46.1594H48.1468H49.5768",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_89_2",
    x1: 34.5094,
    y1: 14.4118,
    x2: 50.7097,
    y2: 14.4118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07ECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4325,
    stopColor: "#554AFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F913E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_89_2",
    x1: 53.2428,
    y1: 14.4118,
    x2: 68.3063,
    y2: 14.4118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07ECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4325,
    stopColor: "#554AFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F913E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_89_2",
    x1: 70.4676,
    y1: 14.4118,
    x2: 84.6784,
    y2: 14.4118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07ECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4325,
    stopColor: "#554AFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F913E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_89_2",
    x1: 86.6679,
    y1: 14.4118,
    x2: 104.005,
    y2: 14.4118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07ECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4325,
    stopColor: "#554AFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F913E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_89_2",
    x1: 6.84306e-7,
    y1: 13.9972,
    x2: 18.0323,
    y2: 13.9972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07ECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4325,
    stopColor: "#554AFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F913E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_89_2",
    x1: 10.8106,
    y1: 16.9019,
    x2: 27.8141,
    y2: 16.9019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07ECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4325,
    stopColor: "#554AFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F913E4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.61ae60426d94aa0b305719a3f6a66f0e.svg";
export { ForwardRef as ReactComponent };